import React from "react";
import PropTypes from "prop-types";
import Interview from "./Interview/Interview";
import Competencies from "./Competencies/Competencies";
import WithdrawCandidate from "./WithdrawCandidate/WithdrawCandidate";
import JobOffer from "./JobOffer/JobOffer";

const RecruiterKanbanModalContent = ({
  cardUpdateNewColumn,
  closeActionModalAfterReset,
  closeActionModalAfterSubmit,
  fetchKanbanData,
  cardData,
  handleCancelRecruiterConfirmation,
  jobCurrencySymbol,
}) => {
  if (
    ["phone-interview", "first-interview", "second-interview"].indexOf(
      cardUpdateNewColumn
    ) > -1
  ) {
    return (
      <Interview
        closeActionModalAfterReset={closeActionModalAfterReset}
        closeActionModalAfterSubmit={closeActionModalAfterSubmit}
        handleCancelRecruiterConfirmation={handleCancelRecruiterConfirmation}
        cardData={cardData}
        fetchKanbanData={fetchKanbanData}
        interviewType={cardUpdateNewColumn}
      />
    );
  } else if (cardUpdateNewColumn === "competencies") {
    return (
      <Competencies
        closeActionModalAfterReset={closeActionModalAfterReset}
        closeActionModalAfterSubmit={closeActionModalAfterSubmit}
        cardData={cardData}
        fetchKanbanData={fetchKanbanData}
      />
    );
  } else if (cardUpdateNewColumn === "job-offer") {
    return (
      <JobOffer
        closeActionModalAfterReset={closeActionModalAfterReset}
        closeActionModalAfterSubmit={closeActionModalAfterSubmit}
        handleCancelRecruiterConfirmation={handleCancelRecruiterConfirmation}
        cardData={cardData}
        fetchKanbanData={fetchKanbanData}
        jobCurrencySymbol={jobCurrencySymbol}
      />
    );
  }

  return (
    <WithdrawCandidate
      closeActionModalAfterReset={closeActionModalAfterReset}
      closeActionModalAfterSubmit={closeActionModalAfterSubmit}
      handleCancelRecruiterConfirmation={handleCancelRecruiterConfirmation}
      cardData={cardData}
      fetchKanbanData={fetchKanbanData}
    />
  );
};

RecruiterKanbanModalContent.propTypes = {
  cardUpdateNewColumn: PropTypes.string.isRequired,
  closeActionModalAfterReset: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({}).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
  handleCancelRecruiterConfirmation: PropTypes.func.isRequired,
  handleModalTitle: PropTypes.func.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
};

export default RecruiterKanbanModalContent;
